import { FC } from 'react'

type Props = {
  className?: string
}

const BrokenImageIcon: FC<Props> = ({ className }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M42.5 9V39C42.5 40.5 41 42 39.5 42H28.25L26 39.2727H39.6825V32.4L33.9454 24C33.4946 23.4545 32.6493 23.4545 32.1985 24L27.8596 29.0727L23.746 24L28.1977 18.5455C28.5921 18.0545 28.5921 17.3455 28.1977 16.8545L23.746 11.4L28.25 6H39.5C41 6 42.5 7.5 42.5 9ZM9.31752 38.0182V39.2727H22.25L24.5 42H9.5C8 42 6.5 40.5 6.5 39V9C6.5 7.5 8 6 9.5 6H24.5L20.8158 10.5818C20.4213 11.0727 20.4213 11.7818 20.8158 12.2182L25.2674 17.6727L20.8158 23.1273C20.4213 23.6182 20.4213 24.3273 20.8158 24.8182L25.2674 30.2727L21.2666 35.1818C21.2666 35.1818 21.0975 35.0727 21.0412 34.9636L16.5895 29.7818C16.1387 29.2364 15.2934 29.2364 14.8426 29.7818L9.31752 38.0182ZM12.2505 17.1818C12.2505 19.4727 14.1664 21.3273 16.5331 21.3273C18.8998 21.3273 20.8158 19.4727 20.8158 17.1818C20.8158 14.8909 18.8998 13.0364 16.5331 13.0364C14.1664 13.0364 12.2505 14.8909 12.2505 17.1818Z"
      fill="currentColor"
    />
  </svg>
)

export default BrokenImageIcon
